import React, { createContext } from "react";


const generalContext = React.createContext({imageToDisplay:{}, setImageToDisplay:{}});


export { generalContext };